import { FormattedMessage, injectIntl } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { compose, graphql } from "react-apollo";

import Button from "../../elements/CustomButton/CustomButton";
import CurrencySpan from "../Currency/CurrencySpan";
// import PropTypes from "prop-types";
import Queries from "../../queries/queries2";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import Table from "../../elements/Table/Table";
import _ from "lodash-es";
import { pure } from "recompose";
import { withRouter } from "react-router-dom";

// import { FormattedMessage } from "react-intl";

// const aggregatedColor = "DarkGray";

// categories de type Frais
const data = graphql(Queries.getCategoriesForBudget, {
  options: ({ companyId }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        companyId,
        categoryId: ""
      }
    };
  }
});

// const data = graphql(Queries.getAllCategories, {
//   options: ({ companyId }) => {
//     let filter = {
//       id_not: null,
//       OR: [
//         {
//           company: { id: companyId }
//         },
//         {
//           AND: [
//             {
//               company: null
//             },
//             {
//               categoryFamily: { administrable: true }
//             }
//           ]
//         }
//       ]
//     };
//     filter = { ...filter };
//     return {
//       fetchPolicy: "cache-and-network",
//       variables: {
//         companyId,
//         where: filter
//       }
//     };
//   }
// });

let BudgetCategoryList = ({
  history,
  data: { getCategoriesForBudget },
  onRowSelect,
  setSideModalVisible,
  setCategoryId,
  // setIsGeneric,
  // setIsEdit,
  intl,
  handleEditBudget,
  currentYear,
  nextYear,
  role,
  showBackupModal,
  getHistory,
  getHistory2,
  attributesArray,
  orderArray
}) => {
  console.log("BudgetCategoryList render", getCategoriesForBudget);
  if (data.loading || !getCategoriesForBudget) {
    return <Spinner size="lg" fullScreen />;
  }

  let { edges } = getCategoriesForBudget;

  // TRANSLATIONS.....
  _.forEach(edges, o => {
    // translates category name if ids present, else it is generic
    // and doesnt need translation
    if (o.node && o.node.ids !== null) {
      // console.log("=>", o.node.category.ids);
      o.node.name = intl.formatMessage({
        id: o.node.ids
      });
    }

    if (o.node && o.node.categoryFamily && o.node.categoryFamily.ids !== null) {
      o.node.categoryFamily.name = intl.formatMessage({
        id: o.node.categoryFamily.ids
      });
    }
  });

  let pivots = ["family" /*, "name"*/];

  let sortedEdges = [];
  if (edges) {

    if (attributesArray)
      sortedEdges = _.orderBy(edges, attributesArray, orderArray);
    else
      sortedEdges = _.orderBy(
        edges,
        ["node.categoryFamily.name", "node.name"],
        ["asc", "asc"]
      );
  }

  const hideLinks = false;

  console.log("getCategoriesForBudget", getCategoriesForBudget);
  return (
    <div>
      <Table
        tableName="category"
        // dock={[
        //   <Button key="save" icon pullRight onClick={showBackupModal}>
        //     <FormattedMessage id="ids_save" />
        //   </Button>
        // ]}
        visibleColumns={[
          // {
          //   name: "active",
          //   type: "categoryActive",
          //   accessor: "companySettings[0].active",
          //   className: "text-center",
          //   // maxWidth: "120px",
          //   filterable: false,
          //   Aggregated: row => {
          //     return <div />;
          //   }
          // },

          {
            id: "family",
            name: "family",
            type: "string",
            accessor: "node.categoryFamily.name",
            maxWidth: 320,
            expanded: true
          },
          {
            id: "name",
            name: "category",
            maxWidth: 360,

            Cell: row => {
              // console.log("cell status", row);
              // const hasCompany = row.original && row.original.company !== null;

              if (row.original && row.original.node) {
                const { company, name } = row.original && row.original.node;

                return (
                  <div title={name}>
                    {name}
                    {!company && (
                      <i title="non manageable" className="fa fa-lock" />
                    )}
                  </div>
                );
              } else return <div />;
            },
            // maxWidth: "300px",
            accessor: "node.name",
            Aggregated: row => <div />
          },

          {
            id: "supplier",
            name: `${intl.formatMessage({
              id: "tiers"
            })}`,
            type: "string",
            accessor: d => {
              return (
                (d.node &&
                  d.node.budgetTiersSupplier &&
                  d.node.budgetTiersSupplier.name) ||
                ""
              );
            },
            Cell: row => {
              const value = row.value;

              if (!!!hideLinks) {
                let toolTipText = "";
                let pushURL = "";
                let showIcon = false;
                if (row && row.original) {
                  if (
                    row &&
                    row.original &&
                    row.original.node &&
                    row.original.node.budgetTiersSupplier &&
                    row.original.node.budgetTiersSupplier.collaborator &&
                    row.original.node.budgetTiersSupplier.collaborator.id
                  ) {
                    showIcon = true;
                    pushURL = `/collaborators/${
                      row.original.node.budgetTiersSupplier.id
                      }/show`;
                    toolTipText = (
                      <FormattedMessage id="ids_goToCollaborator" />
                    );
                  } else if (
                    row &&
                    row.original &&
                    row.original.node &&
                    row.original.node.budgetTiersSupplier &&
                    row.original.node.budgetTiersSupplier.supplier &&
                    row.original.node.budgetTiersSupplier.supplier.id
                  ) {
                    showIcon = true;
                    pushURL = `/suppliers/${
                      row.original.node.budgetTiersSupplier.id
                      }/show`;
                    toolTipText = <FormattedMessage id="ids_goToSupplier" />;
                  } else if (
                    row &&
                    row.original &&
                    row.original.node &&
                    row.original.node.budgetTiersSupplier &&
                    row.original.node.budgetTiersSupplier.client &&
                    row.original.node.budgetTiersSupplier.client.id
                  ) {
                    showIcon = true;
                    pushURL = `/clients/${
                      row.original.node.budgetTiersSupplier.id
                      }/show`;
                    toolTipText = <FormattedMessage id="ids_goToClient" />;
                  }
                }

                // console.log("   pushURL =", pushURL);
                // console.log("   showIcon=", showIcon);

                const toolTip = (
                  <Tooltip id="tooltip">
                    <p>{toolTipText}</p>
                  </Tooltip>
                );

                const icon = (
                  <OverlayTrigger placement="top" overlay={toolTip}>
                    <Button
                      icon
                      wd
                      bsStyle="primary"
                      style={{
                        minWidth: "inherit",
                        border: "none",
                        padding: "0px 0px 0px 0px",
                        margin: "-3px 1px 0px 0px",
                        borderRadius: "100%"
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        // console.log("CLICK...");
                        history.push(pushURL);
                      }}
                      className="text-primary fa-lg fa fa-user"
                    // style={{ paddingRight: "20px" }}
                    />
                  </OverlayTrigger>
                );

                if (showIcon) {
                  return (
                    <div>
                      {icon}
                      {value}
                    </div>
                  );
                }
                return <div>{value}</div>;
              } else {
                return <div>{value}</div>;
              }
            },
            maxWidth: 140,
            Aggregated: row => <div />
          },
          {
            id: "clientOrProject",
            name: `${intl.formatMessage({
              id: "clientOrProject"
            })}`,
            type: "string",
            accessor: d => {
              return (
                (d.node &&
                  d.node.budgetProject &&
                  d.node.budgetProject.name &&
                  d.node.budgetProject.name !== "N_A" &&
                  d.node.budgetProject.name) ||
                (d.node &&
                  d.node.budgetTiersClient &&
                  d.node.budgetTiersClient.name &&
                  d.node.budgetTiersClient.name) ||
                ""
              );
            },
            maxWidth: 140,
            Aggregated: row => <div />
          },
          {
            // name: "currentBudget",
            noTranslateColumnName: true,
            name: `${intl.formatMessage({
              id: "ids_budget"
            })} ${currentYear}`,
            type: "currency",
            digit: 0,
            accessor: "node.budgetCurrent",
            maxWidth: 140,
            badges: args => {
              // console.log("onClickhandleEditBudget__", args);
              let classN = "fa fa-pencil text-primary pointer";

              if (args && args.node) {
                if (
                  args.node.id ===
                  "fake_id_for_according_to_budget_client_null_null"
                ) {
                  classN = "fa fa-ban text-primary pointer";
                } else {
                  if (
                    args &&
                    args.node &&
                    args.node.budgetCurrent === null &&
                    args.node.budgetNext === null
                  ) {
                    classN = "fa fa-plus text-primary pointer";
                  }

                  if (
                    args &&
                    args.node &&
                    args.node.budgetCurrent === 0 &&
                    args.node.budgetNext === 0
                  ) {
                    classN = "fa fa-plus text-warning pointer";
                  }
                }
              }

              return (
                <i
                  className={classN}
                  onClick={() => {
                    // console.log("OnClick =", args);
                    const node = {
                      ...args.node,
                      id: "",
                      selectedId: args.node.id
                    };
                    if (args && args.node && args.node.id) {
                      if (
                        args.node.id !==
                        "fake_id_for_according_to_budget_client_null_null"
                      ) {
                        let str = "" + args.node.id;
                        if (str.substring(0, 5) === "fake_") {
                          str = str.substring(5, str.length);
                          node.id = str.substring(0, str.indexOf("_"));
                        } else node.id = args.node.id;

                        // console.log("3 - onClickhandleEditBudget", node);
                        handleEditBudget(node, sortedEdges);
                      } else {
                        history.push(`/budget/clients`);
                      }
                    }
                  }}
                />
              );
            },
            aggregate: vals => _.sum(vals),
            Aggregated: row => (
              <div
                style={{
                  // color: row.isExpanded ? aggregatedColor : "Inherit",
                  fontWeight: row.isExpanded ? "bold" : "Inherit",
                  textAlign: row.isExpanded ? "left" : "Inherit"
                }}
              >
                <CurrencySpan digit={0} value={row.value} />
              </div>
            )
          },
          {
            noTranslateColumnName: true,
            name: `${intl.formatMessage({
              id: "ids_budget"
            })} ${nextYear}`,
            type: "currency",
            digit: 0,
            accessor: "node.budgetNext",
            maxWidth: 130,
            badges: args => {
              // console.log("onClickhandleEditBudget__", args);
              let classN = "fa fa-pencil text-primary pointer";
              // let toolTipText = (
              //   <FormattedMessage id="ids_editBudget" />
              // );

              if (args && args.node && args.node.id) {
                if (
                  args.node.id ===
                  "fake_id_for_according_to_budget_client_null_null"
                ) {
                  classN = "fa fa-ban text-primary pointer";
                } else {
                  if (
                    args &&
                    args.node &&
                    args.node.budgetCurrent === null &&
                    args.node.budgetNext === null
                  ) {
                    classN = "fa fa-plus text-primary pointer";

                    // toolTipText = (
                    //   <FormattedMessage id="ids_createBudget" />
                    // );
                  }

                  if (
                    args &&
                    args.node &&
                    args.node.budgetCurrent === 0.0 &&
                    args.node.budgetNext === 0.0
                  ) {
                    classN = "fa fa-plus text-warning pointer";

                    // toolTipText = (
                    //   <FormattedMessage id="ids_createBudget" />
                    // );
                  }
                }
              }

              // const toolTip = (
              //   <Tooltip id="tooltip">
              //     <p>{toolTipText}</p>
              //   </Tooltip>
              // );

              return (
                // <OverlayTrigger placement="top" overlay={toolTip}>
                <i
                  className={classN}
                  onClick={() => {
                    // console.log("OnClick =", args);
                    const node = {
                      ...args.node,
                      id: "",
                      selectedId: args.node.id
                    };
                    if (args && args.node && args.node.id) {
                      if (
                        args.node.id !==
                        "fake_id_for_according_to_budget_client_null_null"
                      ) {
                        let str = "" + args.node.id;
                        if (str.substring(0, 5) === "fake_") {
                          str = str.substring(5, str.length);
                          node.id = str.substring(0, str.indexOf("_"));
                        } else node.id = args.node.id;

                        // console.log("3 - onClickhandleEditBudget", node);
                        handleEditBudget(node, sortedEdges);
                      } else {
                        history.push(`/budget/clients`);
                      }
                    }
                  }}
                />
                // </OverlayTrigger>
              );
            },
            aggregate: vals => _.sum(vals),
            Aggregated: row => (
              <div
                style={{
                  // color: row.isExpanded ? aggregatedColor : "Inherit",
                  fontWeight: row.isExpanded ? "bold" : "Inherit",
                  textAlign: row.isExpanded ? "left" : "Inherit"
                }}
              >
                <CurrencySpan digit={0} value={row.value} />
              </div>
            )
          },
          // {
          //   name: `${intl.formatMessage({
          //     id: "budgetOrReal"
          //   })}`,
          //   accessor: "node.budgetIsReal",
          //   maxWidth: 40,
          //   Cell: row => {
          //     if (!!!row.value) {
          //       return <i className="fa fa-line-chart" />;
          //     }
          //     return (
          //       <div>
          //       </div>
          //     );
          //   },
          //   maxWidth: 40,
          //   Aggregated: row => <div />
          // },
          {
            noTranslateColumnName: true,
            id: "budgetOrReal",
            name: "",
            // name: `${intl.formatMessage({
            //   id: "budgetOrReal"
            // })}`,
            type: "string",
            accessor: d => {
              if (d.node) {
                if (d.node.budgetIsReal === false) {
                  return "B";
                }
              }
              return "";
            },
            maxWidth: 28,
            Aggregated: row => <div />
          }

          // {
          //   name: "categoriesParent",
          //   type: "string",
          //   accessor: "categoriesParent.name"
          // },
        ]}
        data={sortedEdges}
        pivotBy={pivots}
        onRowSelect={onRowSelect}
        // onRowClick={id => {
        //   setCategoryId(id);
        //   setEdit(true);
        //   setSideModalVisible(true);
        // }}
        // onRowClick={(id, state, rowInfo, column, instance) => {
          // console.log("id", id);
          // console.log("state", state);
          // console.log("rowInfo", rowInfo);
          // console.log("column", column);
          // console.log("instance", instance);
          // if (rowInfo.original && rowInfo.original.company)
          //   setIsGeneric(false);
          // else {
          //   setIsGeneric(true);
          // }
          // setCategoryId(id);
          // setIsEdit(true);
          // setSideModalVisible(true);
        // }}
        onRowClick={(args, row, rowInfo) => {  
          const node = {
            ...rowInfo.original.node,
            id: "",
            selectedId: rowInfo.original.node.id
          };
          if (rowInfo && rowInfo.original && rowInfo.original.node && rowInfo.original.node.id) {
            if (
              rowInfo.original.node.id !==
              "fake_id_for_according_to_budget_client_null_null"
            ) {
              let str = "" + rowInfo.original.node.id;
              if (str.substring(0, 5) === "fake_") {
                str = str.substring(5, str.length);
                node.id = str.substring(0, str.indexOf("_"));
              } else node.id = rowInfo.original.node.id;

              // console.log("3 - onClickhandleEditBudget", node);
              handleEditBudget(node, sortedEdges);
            } else {
              history.push(`/budget/clients`);
            }
          }
        }}
        selectRow={false}
        expandAll={true}
        onGetHistory={role === "ADMIN" ? getHistory : undefined}
        onGetHistory2={role === "ADMIN" ? getHistory2 : undefined}
        onCreateBudgetBackup={role === "ADMIN" ? showBackupModal : undefined}
        onSortedChange={(arg) => {

          attributesArray = new Array();
          orderArray = new Array();

          // var data = _.orderBy(array_of_objects, ['type','name'], ['asc', 'desc']);
          let addName = true;
          for (const element of arg) {
            attributesArray.push("node." + element.id);
            orderArray.push(element.desc ? "desc" : "asc");

            if (element.id === "name")
              addName = false;
          }
          sortedEdges = _.orderBy(edges, attributesArray, orderArray);
        }}
      // pivotBy={["categoryFamily.name"]}
     
      defaultSorted={[
        {
          id: "family",
          asc: true
        },
        {
          id: "name",
          asc: true
        }
      ]}
      />

      {/* for the Table above, when Edit is possible
          onRowClick={id => {
            history.push(`/settings/categories/${id}/edit`);
          }}
        */}
    </div>
  );
};

export default compose(
  data,
  pure
)(injectIntl(withRouter(BudgetCategoryList)));
